import React from 'react';
import IconBase from './IconBase';

const AdminIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M12,21.4h-0.2c-0.1,0-0.1,0-0.2,0c-2-0.7-3.7-2-5.1-3.9c-1.3-1.9-2-4-2-6.4V6.6c0-0.4,0.1-0.7,0.3-1S5.3,5,5.7,4.9l5.7-2.1c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0.1l5.7,2.1C18.7,5,19,5.2,19.2,5.5s0.3,0.6,0.3,1v4.5c0,2.3-0.7,4.5-2,6.4c-1.3,1.9-3,3.2-5,3.9C12.4,21.3,12.2,21.4,12,21.4z"/>
        </IconBase>
    )
}

export default AdminIcon;